module.exports = __webpack_public_path__ + "images/icon-download.png?72e8405463a25d80a8fb7db04a1cf7e2";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/assets/images/icon-download.png
// module id = 995
// module chunks = 0